import React, { useCallback } from "react";
import { useEditorState } from "@/store";

type DocumentationProps = {
  id: string;
  src: string;
};

export const Documentation: React.FC<DocumentationProps> = ({ id, src }) => {
  const { registerDocumentationRef, unregisterDocumentationRef, theme } = useEditorState();

  const callbackRef = useCallback((el: HTMLIFrameElement | null) => {
    if (el) {
      registerDocumentationRef(id, el);
    } else {
      unregisterDocumentationRef(id);
    }
  }, [id]);
  const url = new URL(src);
  url.searchParams.set("theme", theme);

  return (
    <div className={`w-full h-full relative no-scrollbar`}>
      <iframe
        id={`documentation-iframe-${id}`}
        className={`w-full h-full no-scrollbar`}
        allowFullScreen
        allow="cross-origin-isolated; clipboard-read; clipboard-write; camera *; microphone *;"
        ref={callbackRef}
        src={url.toString()}
      />
    </div>
  );
};
